export default {
    routerName: '标签管理',
    tag: {
        searchName: '检索条件',
        name: '标签名',
        sortOrder: '排序',
        status: '状态',
        open: '启用',
        close: '停用',
        createBy: '创建者',
        createTime: '创建时间',
        createStartTime: '创建开始时间',
        createEndTime: '创建结束时间',
    },
    table: {
        id: 'ID',
        name: '标签名',
        sortOrder: '排序',
        createBy: '创建者',
        createTime: '创建时间',
        status: '状态',
    },
};
